/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : jry
 * @lastTime     : 2025-08-16 16:32:24
 * @FilePath     : /uview-plus/libs/config/props/album.js
 */
export default {
    // album 组件
    album: {
        urls: [],
        keyName: '',
        singleSize: 180,
        multipleSize: 70,
        space: 6,
        singleMode: 'scaleToFill',
        multipleMode: 'aspectFill',
        maxCount: 9,
        previewFullImage: true,
        rowCount: 3,
        showMore: true,
        autoWrap: false,
        unit: 'px',
        stop: true,
    }
}
